import { z } from 'zod';
import { DeviceLogin } from '../../gateway/v1/index.js';
/**
 * One row of a device's connection history (GET /api/v1/devices/:id/connections, device.view). Raw facts of the
 * `device_connections` row plus two derived from the device's previous connection (by `connected_at`):
 *  - `previous_disconnect_reason`: why the previous connection ended (null for the first known connection);
 *  - `gap_since_previous_s`: `connected_at − previous.disconnected_at` in seconds; negative when the previous
 *    connection was closed as `superseded` after this one had already connected; null without a closed previous row.
 * No class/health is inferred here; `login` is stored as the gateway reported it (gateway/v1 `device.identified.login`).
 */
export const DeviceConnection = z.object({
    id: z.uuid(),
    connected_at: z.string(),
    identified_at: z.string().nullable(),
    disconnected_at: z.string().nullable(),
    /** disconnected_at − connected_at, seconds; null while the connection is open */
    duration_s: z.number().int().nullable(),
    /** gateway/v1 DisconnectReason, or Central's own `not_in_snapshot` */
    disconnect_reason: z.string().nullable(),
    remote_addr: z.string().nullable(),
    local_port: z.number().int().nullable(),
    /** protocol profile key of the connection */
    protocol: z.string().nullable(),
    firmware: z.string().nullable(),
    login: DeviceLogin.nullable(),
    /** final session counters (rx_bytes, tx_bytes, rx_segments, tx_segments, …) when the gateway reported them */
    counters: z.record(z.string(), z.number()),
    previous_disconnect_reason: z.string().nullable(),
    gap_since_previous_s: z.number().int().nullable(),
});
/** GET /api/v1/devices/:id/connections?limit= (default 20, max 200) — newest first. */
export const DeviceConnections = z.object({
    device_id: z.uuid(),
    items: z.array(DeviceConnection),
});
//# sourceMappingURL=connections.js.map